/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useState } from "react"
import logoTinabaBianco from "../images/tinaba/logo_tinaba_bianco_orizzontale.png"

import instragramFooter from '../images/footer/instagram_footer.png';
import facebookFooter from '../images/footer/facebook_footer.png';
import twitterFooter from '../images/footer/twitter_footer.png';
import youtubeFooter from '../images/footer/youtube_footer.png';
import linkedinFooter from '../images/footer/linkedin_footer.png';
import googlePlay from '../images/landing/google-play.png';
import appleStore from '../images/landing/apple-store.png';
import huaweiStore from '../images/landing/huawei-store.png';
import arrowDown from '../images/arrow_down.png';

import * as s from "./css/footer.module.css";

const links1 = [
    { title: 'Chi siamo', url: 'https://bancaprofilo.tinaba.it/chi-siamo' },
    { title: 'Banca Profilo', url: 'https://bancaprofilo.tinaba.it/banca-profilo' },
    { title: 'Lavora con noi', url: 'https://bancaprofilo.tinaba.it/lavora-con-noi' },
    { title: 'Stampa', url: 'https://bancaprofilo.tinaba.it/area-stampa' },
    { title: 'Aiuto', url: 'https://bancaprofilo.tinaba.it/aiuto' },
];

const links2 = [
    { title: 'Un mondo di Pay', url: 'https://bancaprofilo.tinaba.it/un-mondo-di-pay' },
    { title: 'Tinaba e Alipay', url: 'https://bancaprofilo.tinaba.it/tinaba-e-alipay' },
    { title: 'Google Pay', url: 'https://bancaprofilo.tinaba.it/google-pay' },
    { title: 'Apple Pay', url: 'https://bancaprofilo.tinaba.it/apple-pay' },
]

const links3 = [
    { title: 'Trasparenza', url: 'https://bancaprofilo.tinaba.it/trasparenza' },
    { title: 'Manuale d\'uso', url: 'https://bancaprofilo.tinaba.it/manuale-d-uso' },
    { title: 'E-Commerce', url: 'https://bancaprofilo.tinaba.it/e-commerce' },
    { title: 'Blog', url: 'https://blog.tinaba.bancaprofilo.it/' },
]

const links4 = [
    { title: 'Documenti legali', url: 'https://bancaprofilo.tinaba.it/documenti-legali' },
    { title: 'Promozioni e regolamenti', url: 'https://bancaprofilo.tinaba.it/promozioni-e-regolamenti' },
    { title: 'Informativa sulla Privacy', url: 'https://bancaprofilo.tinaba.it/privacy-policy' },
    { title: 'Impostazioni cookie', url: 'https://bancaprofilo.tinaba.it/impostazioni-cookie' },
]

const MenuItem = ({ hasMT = true, title, links, menuShown, setMenuShown }) => {
    return (
        <div className={`col-span-4 desktop:col-span-2 mx-2 desktop:mx-0 desktop:mt-0 ${hasMT ? 'mt-8' : ''}`}>
            <button className="text-primary font-bd text-6_5 w-full flex items-center cursor-pointer desktop:cursor-default" onClick={() => { setMenuShown(menuShown === title ? null : title) }}>
                <span className="flex-grow text-left">{title}</span>
                <img className={`desktop:hidden object-contain float-right transform ${menuShown === title ? 'rotate-180' : 'rotate-0'}`} src={arrowDown} alt="Apri / chiudi menu" />
            </button>
            <div className={`${menuShown === title ? "block" : "hidden"} desktop:block`}>
                {links.map((l, indexL) => <div key={`menuItem_${indexL}`} className={`text-black font-rg text-8 mt-8`}><a href={l.url} target="_blank" rel="noreferrer">{l.title}</a></div>)}
            </div>
        </div>
    );
}

const Footer = ({ data }) => {

    const [menuShown, setMenuShown] = useState(null);

    return (
        <>
            <div className="full-container flex flex-col mt-48" style={{ backgroundColor: '#f6f6f6', paddingTop: '66px', paddingBottom: '66px' }}>
                <div className="container-grid">
                    <MenuItem hasMT={false} title="Tinaba" links={links1} menuShown={menuShown} setMenuShown={setMenuShown} />
                    <MenuItem title="Mobile Payment" links={links2} menuShown={menuShown} setMenuShown={setMenuShown} />
                    <MenuItem title="Link utili" links={links3} menuShown={menuShown} setMenuShown={setMenuShown} />
                    <MenuItem title="Informative e Policy" links={links4} menuShown={menuShown} setMenuShown={setMenuShown} />

                    <div className="col-span-4 desktop:col-span-2" />

                    <div className="col-span-4 mt-24 desktop:col-span-2 desktop:mt-0 mx-2 desktop:mx-0">
                        <div className="text-primary font-bd text-6_5">Scarica l'App</div>
                        <div className="flex flex-col mt-8">
                            <a href="https://play.google.com/store/apps/details?id&#x3D;it.tinaba.app" target="_blank" rel="noreferrer">
                                <img className="mb-3 w-48" src={googlePlay} alt="" />
                            </a>
                            <a href="https://apps.apple.com/it/app/id1063359568" target="_blank" rel="noreferrer">
                                <img className="mb-3 w-48" src={appleStore} alt="" />
                            </a>
                            <a href="https://appgallery.huawei.com/#/app/C102692785" target="_blank" rel="noreferrer">
                                <img className="w-48" src={huaweiStore} alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="full-container bg-primary" style={{ paddingTop: '32px', paddingBottom: '32px' }}>
                <div className="container">
                    <div className="flex flex-col-reverse desktop:flex-row">
                        <div className="flex flex-col flex-grow">
                            <div className="flex flex-col desktop:flex-row">
                                <a href="https://www.tinaba.it" className={`${s.containerLogoTinaba}`} target="tinaba">
                                    <img src={logoTinabaBianco} alt="Tinaba" style={{height:'100%'}} />
                                </a>
                            </div>
                            <div className={`mx-4 font-rg text-white text-9 desktop:text-8 ${s.datiAzienda}`}>
                                © 2020 Tinaba S.p.A. P.I. 09158950965 – REA MI 2072 562 Via Cerva 28, 20122 Milano (MI)
                            </div>

                        </div>

                        <div className="flex-auto flex flex-row items-center">
                            <div className="mx-4 flex flex-row flex-grow justify-between desktop:justify-end">
                                <a href="https://www.instagram.com/tinaba_app/"
                                    className={s.linkSocial} target="_blank" rel="noreferrer">  
                                    <img className="w-full h-full object-contain" src={instragramFooter} alt="" />
                                </a>
                                <a href="https://www.facebook.com/TinabaOfficial/"
                                    className={s.linkSocial} target="_blank" rel="noreferrer">
                                    <img className="w-full h-full object-contain" src={facebookFooter} alt="" />
                                </a>
                                <a href="https://twitter.com/TinabaOfficial"
                                    className={s.linkSocial} target="_blank" rel="noreferrer">
                                    <img className="w-full h-full object-contain" src={twitterFooter} alt="" />
                                </a>
                                <a href="https://www.youtube.com/channel/UCmOdkb7KUseVSHDTYCM3gCg"
                                    className={s.linkSocial} target="_blank" rel="noreferrer">
                                    <img className="w-full h-full object-contain" src={youtubeFooter} alt="" />
                                </a>
                                <a href="https://www.linkedin.com/company/tinaba/"
                                    className={s.linkSocial} target="_blank" rel="noreferrer">
                                    <img className="w-full h-full object-contain" src={linkedinFooter} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Footer
